var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerCellularTowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1E124A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.08-299.08q-55.46-56.15-81.89-123-26.42-66.84-26.42-137.92 0-71.08 26.42-137.92 26.43-66.85 81.89-123l26.46 26.46Q196-744.15 172-683.58 148-623 148-560t24 123.58q24 60.57 73.54 110.88l-26.46 26.46ZM312-392q-34.38-35.92-51.81-79.54-17.42-43.61-17.42-88.46 0-44.85 17.42-88.46Q277.62-692.08 312-728l26.46 26.46q-29.23 28.54-43.84 65.92Q280-598.23 280-560q0 37.54 14.23 74.54 14.23 37 44.23 67L312-392Zm11.08 245.85 116.54-349.62q-17.54-10.15-27.04-28t-9.5-36.23q0-32 22.46-54.46T480-636.92q32 0 54.46 22.46T556.92-560q0 18.38-8.73 35.46-8.73 17.08-27.81 28.77l116.54 349.62h-41.54l-26-80H390.85l-25.47 80h-42.3Zm81.46-120h150.92L480-493.85l-75.46 227.7ZM648-392l-26.46-26.46q29.23-28.54 43.84-65.92Q680-521.77 680-560q0-35.23-14.62-73-14.61-37.77-43.84-68.54L648-728q34.38 35.92 51.46 80.31 17.08 44.38 17.77 88.46 0 44.85-17.04 88.08T648-392Zm92.92 92.92-26.46-26.46Q764-375.85 788-436.42 812-497 812-560t-24-123.58q-24-60.57-73.54-110.88l26.46-26.46q54.7 56.15 81.5 123 26.81 66.84 26.81 137.92 0 71.08-25.69 137.92-25.69 66.85-82.62 123Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCellularTowerIcon);
export default __webpack_public_path__ + "static/media/marker-cellular-tower-icon.30b83792693c04ca2cdc650e81479d52.svg";
export { ForwardRef as ReactComponent };